<template>
  <div>
    <el-table :data="form.list" border style="width: 100%">
      <el-table-column fixed prop="name" label="名称" align="center" >
      </el-table-column>
      <el-table-column prop="name" label="汇率" align="center" >
        <template slot-scope="scope"  >
            <el-input v-model="scope.row.exchange_rate" placeholder="请输入内容"></el-input>
        </template>
      </el-table-column>
      <el-table-column  label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button @click="save(scope.row)" type="text" size="small">保存</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    admin_Config_list,
    admin_Config_update
  } from '@/api/xgcApi'
  export default {
    components: {

    },
    filters: {},
    data() {
      return {
        form: {
          list: []
        },

      }
    },
    computed: {},
    created() {},

    mounted() {
      this.getList()
    },
    methods: {
      getList() {
        var data = {}
        admin_Config_list(data).then(res => {
          this.form.list = res.data.list
        })
      },
      save(row){
        var data = row
        admin_Config_update(data).then(res=>{
          console.log(res)
          this.$message({
            type:'success',
            message:'操作成功'
          })
          this.getList()
        })
      },
      onSubmit() {

      }
    },
  }
</script>

<style scoped>

</style>
